import * as React from 'react';
import { ReactNode } from 'react';
import { Divider } from 'primereact/divider';

interface Props {
  title: string;
  children: ReactNode | ReactNode[];
}

export const Row = (props: Props): ReactNode => {
  const children = Array.isArray(props.children) ? props.children : [props.children];
  return <div className={'flex flex-column md:flex-row row-gap-4'}>
    <div className={'w-12 md:w-4'}>
      <label><strong>{props.title}: </strong></label>
    </div>
    <div className={'w-12 md:w-8 flex flex-column gap-1'}>
      {children.map((child: ReactNode, index: number, array: ReactNode[]): ReactNode => (
        <div key={index}>
          {child}
          {index + 1 < array.length && <Divider className={'my-1'} type={'dashed'}/>}
        </div>
      ))}
    </div>
  </div>;
};
